import React from 'react';
import './App.css';
import ProfileHeader from './ProfileHeader';
import ContactButtons from './ContactButtons';
import NextButtons from './ContactButtonNext';
import CourselPage from './Coursel';
// Import other components similarly

function App() {
  return (
    <div className="App">
        <br/>
        <br/>
      <ProfileHeader />
     <NextButtons/>
     <CourselPage/>
      
    </div>
  );
}

export default App;
